import React from 'react'
import SidebarMenu from '../componets/Home/MenuSidebar/sidebarMenu'
import SeleccionarPais from '../componets/Calendario/Consultar/SeleccionarPais'
import BreadCrumb from '../componets/Home/BreadCrumb'
import { Link } from 'react-router-dom'
import '../assets/css/Sidebar.css'
import Cookies from 'universal-cookie';

const cookies = new Cookies();


const ConsultarCalendario = () => {

    const home = (
        <Link className="breadcrubsLink" to="/registroActividades/inicio">Inicio</Link>
    )

    if (!cookies.get('code')) {
        window.location.href = "/singOff"
    }

   const menu = JSON.parse(sessionStorage.getItem("permissions"))
    const permisos = menu.rol


    if (permisos[10].ConsultarCalendario === "false") {
        window.location.href = "/registroActividades/inicio"
    }

    const consultar = (
        <span className="disabled">Calendario</span>
    )

    return (
        <div>
            <SidebarMenu
                accesoProp={permisos}
            />
            <div className="content">
                <BreadCrumb
                    home={home}
                    consultar={consultar}

                />
                <div className="container">

                    <h1 >Consultar Calendario</h1>

                    <div className="tabla">

                        <SeleccionarPais />

                    </div>

                </div>
            </div>
        </div>

    )
}

export default ConsultarCalendario